import { useDispatch } from "react-redux";

import crmEnrichmentTrackingService from "app/pages/sales-intelligence/modules/crm-enrichment/services/tracking/trackingService";
import {
    setSelectedCountryId,
    setSelectedEnrichmentSource,
    setSelectedJobObject,
    setSelectedJobRefreshPeriod,
    setSelectedLeadScoreRefreshDataInterval,
} from "app/pages/sales-intelligence/modules/crm-enrichment/store/action-creators";
import type {
    CrmEnrichmentJobObject,
    CrmEnrichmentJobRefreshPeriod,
    CrmEnrichmentSource,
    CrmProvider,
    LeadScoreRefreshDataInterval,
} from "app/pages/sales-intelligence/modules/crm-enrichment/types/types";
import type { ICountryObject } from "app/services/CountryService";

type HookParams = {
    crmProvider: CrmProvider;
    onSelectJobObject?: (object: CrmEnrichmentJobObject) => void;
};

type UseJobSettingsActionsReturnType = {
    onSelectJobRefreshPeriod: (period: CrmEnrichmentJobRefreshPeriod) => void;
    onSelectLeadScoreRefreshDataInterval: (interval: LeadScoreRefreshDataInterval | "") => void;
    onSelectCountry: (country: ICountryObject) => void;
    onSelectJobObject: (object: CrmEnrichmentJobObject) => void;
    onSelectEnrichmentSource: (source: CrmEnrichmentSource) => void;
};

const useJobSettingsActions = (params: HookParams): UseJobSettingsActionsReturnType => {
    const dispatch = useDispatch();

    const onSelectJobRefreshPeriod = (period: CrmEnrichmentJobRefreshPeriod) => {
        crmEnrichmentTrackingService.wizard.trackSelectRefreshInterval(period, params.crmProvider);

        dispatch(setSelectedJobRefreshPeriod(period));
    };

    const onSelectLeadScoreRefreshDataInterval = (interval: LeadScoreRefreshDataInterval | "") => {
        if (interval) {
            crmEnrichmentTrackingService.wizard.trackSelectLeadScoreRefreshInterval(interval, params.crmProvider);
        }

        dispatch(setSelectedLeadScoreRefreshDataInterval(interval));
    };

    const onSelectCountry = (country: ICountryObject) => {
        crmEnrichmentTrackingService.wizard.trackSelectCountry(country.text, params.crmProvider);

        dispatch(setSelectedCountryId(country.id));
    };

    const onSelectJobObject = (object: CrmEnrichmentJobObject) => {
        crmEnrichmentTrackingService.wizard.trackSelectObject(object, params.crmProvider);

        dispatch(setSelectedJobObject(object));
        params.onSelectJobObject?.(object);
    };

    const onSelectEnrichmentSource = (source: CrmEnrichmentSource) => {
        crmEnrichmentTrackingService.wizard.trackSelectEnrichmentSource(source, params.crmProvider);

        dispatch(setSelectedEnrichmentSource(source));
    };

    return {
        onSelectJobRefreshPeriod,
        onSelectLeadScoreRefreshDataInterval,
        onSelectCountry,
        onSelectJobObject,
        onSelectEnrichmentSource,
    };
};

export default useJobSettingsActions;
